export type VehicleFinished = {
  message: string;
};
